export const fiber = {
  name: "fiber" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M12 1.6a.9.9 0 0 1 .9.9v8.1h1.2V4.5a.9.9 0 1 1 1.8 0v6.1h.6c1.05 0 1.9.85 1.9 1.9v8a1.9 1.9 0 0 1-1.9 1.9h-9a1.9 1.9 0 0 1-1.9-1.9v-8c0-1.05.85-1.9 1.9-1.9h.6V4.5a.9.9 0 1 1 1.8 0v6.1h1.2V2.5a.9.9 0 0 1 .9-.9ZM7.5 12.4a.1.1 0 0 0-.1.1v8a.1.1 0 0 0 .1.1h9a.1.1 0 0 0 .1-.1v-8a.1.1 0 0 0-.1-.1h-9Z" clip-rule="evenodd"/></svg>`,
  keywords: ["fiber"],
  category: "device" as const,
};
